import { request } from "utils/request";
import { AxiosPromise } from "axios";

export const passportCheckApi = {
  findAll: (params?: any): AxiosPromise<any> =>
    request({
      url: "/v1/admin/passportCheck",
      params,
    }),
  create: (data: any): AxiosPromise<any> =>
    request({
      url: "/v1/admin/passportCheck",
      data,
      method: "post",
    }),
  update: (id: number, data: any): AxiosPromise<any> =>
    request({
      url: `/v1/admin/passportCheck/${id}`,
      method: "patch",
      data,
    }),
  delete: (id: number): AxiosPromise<any> =>
    request({
      url: `/v1/admin/passportCheck/${id}`,
      method: "delete",
    }),
};
